export const shouldComponentRender = (prevProps, nextProps) => {
    
    if(prevProps.lineItemId && nextProps.lineItemId){
        const {cart: prevCart = {}, lineItemId: prevLineItemId, error : prevError = {}} = prevProps;
        const {cart: nextCart = {}, lineItemId: nextLineItemId, error : nextError = {}} = nextProps;
        
        const prevProduct = prevCart?.lineItems[prevLineItemId] ?? [];
        const nextProduct = nextCart?.lineItems[nextLineItemId] ?? [];

        return JSON.stringify(prevProduct) === JSON.stringify(nextProduct) && JSON.stringify(prevError) === JSON.stringify(nextError) && (prevCart?.validDiscountCode === nextCart?.validDiscountCode);
    }
    
    const {cart: prevCart = {}, error : prevError = {}} = prevProps;
    const {cart: nextCart = {}, error : nextError = {}} = nextProps;
        
    return JSON.stringify(prevCart) === JSON.stringify(nextCart) && JSON.stringify(prevError) === JSON.stringify(nextError) && (prevCart?.validDiscountCode === nextCart?.validDiscountCode);
};